module.exports = __webpack_public_path__ + "img/drag-to-answer-white.767401a8.png";